export default {
      id: "icon-pinterest-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "icons.svg#icon-pinterest",
      toString: function () {
        return this.url;
      }
    }